import { inject } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';
import { ErrorBoundary } from 'bernie-view';

import { UitkTab, UitkTabs, UitkTabsType } from 'uitk-react-tabs';

interface TabGroupState {
  currentTab: string;
}

export interface TabInfo {
  id: string;
  label: string;
  rfrr: string;
  content: any;
}

interface TabGroupProps {
  tabs: TabInfo[];
  tabType?: UitkTabsType;
  analytics?: AnalyticsStore;
}

const noop = () => null;
interface TabContextData {
  changeTab: (tabName: string) => any;
  tabs: TabInfo[];
}

export const TabGroupContext = React.createContext<TabContextData>({
  changeTab: noop,
  tabs: []
});

@inject('analytics')
export class TabGroup extends React.Component<TabGroupProps, TabGroupState> {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: props.tabs && props.tabs[0] && props.tabs[0].label
    };

    this.handleTabClick = this.handleTabClick.bind(this);
  }

  public static defaultProps: Partial<TabGroupProps> = {
    tabType: UitkTabsType.NATURAL
  };

  public handleTabClick(currentTab) {
    const { tabs, analytics } = this.props;

    const tab = tabs.find(t => t.label === currentTab);

    if (tab) {
      this.setState({
        currentTab
      });

      if (tab.rfrr && analytics && analytics.clickTracker) {
        analytics.clickTracker(tab.rfrr, tab.id, null, null, null)();
      }
    }
  }

  public render() {
    const { currentTab } = this.state;
    const { tabs, tabType } = this.props;

    const contextData: TabContextData = {
      tabs,
      changeTab: this.handleTabClick
    };

    return (
      <ErrorBoundary label="tabgroup">
        <TabGroupContext.Provider value={contextData}>
          <UitkTabs selectedTab={currentTab} onTabSelect={this.handleTabClick} tabsType={tabType}>
            {tabs.map(({ id, label, content }) => (
              <UitkTab id={id} name={label} key={id}>
                <ErrorBoundary label={`tabgroup-${id}`}>{content}</ErrorBoundary>
              </UitkTab>
            ))}
          </UitkTabs>
        </TabGroupContext.Provider>
      </ErrorBoundary>
    );
  }
}
